<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10 9.18C13.3 6.18 15 4.64 15 2.69C15 1.19 13.75 0 12.25 0C11.39 0 10.57 0.36 10 1C9.43 0.36 8.61 0 7.69 0C6.19 0 5 1.25 5 2.75C5 4.64 6.7 6.18 10 9.18ZM9.18 10C6.18 6.7 4.64 5 2.69 5C1.19 5 0 6.25 0 7.75C0 8.61 0.36 9.43 1 10C0.36 10.57 0 11.39 0 12.31C0 13.81 1.25 15 2.75 15C4.64 15 6.18 13.3 9.18 10ZM10.83 10C13.82 13.3 15.36 15 17.31 15C18.81 15 20 13.75 20 12.25C20 11.39 19.64 10.57 19 10C19.64 9.43 20 8.61 20 7.69C20 6.19 18.75 5 17.25 5C15.36 5 13.82 6.7 10.83 10ZM10 10.82C6.7 13.82 5 15.36 5 17.31C5 18.81 6.25 20 7.75 20C8.61 20 9.43 19.64 10 19C10.57 19.64 11.39 20 12.31 20C13.81 20 15 18.75 15 17.25C15 15.36 13.3 13.82 10 10.82Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "Luck",
};
</script>
